import { render, staticRenderFns } from "./costApply.vue?vue&type=template&id=5f6efdee&scoped=true&"
import script from "./costApply.vue?vue&type=script&lang=js&"
export * from "./costApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6efdee",
  null
  
)

export default component.exports